"use client";

import { useState, useEffect } from "react";
import { cn } from "@costar-ui/cosmos";
import { SearchFilter, ISearchFilterProps } from "./SearchFilter";
import { Button } from "@costar/theme-ui";
import { IconFilters } from "@costar/theme-ui-icons/csg/IconFilters";

export const SearchFilterButton = (props: ISearchFilterProps) => {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("lg:overflow-visible");
    };
  }, []);

  const {
    categoryOptions,
    labelOptions,
    baseUrl,
    redirectUrl,
    keyword,
    messages,
    dateRange,
  } = props;

  const toggleMenu = () => {
    setIsOpen(!isOpen);

    if (!isOpen) {
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("lg:overflow-visible");
      window.scrollTo(0, 0);
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  };

  return (
    <div className="my-auto ml-auto block lg:hidden">
      <Button
        automation-id={"search-filter-button-mobile"}
        iconBefore={<IconFilters />}
        variant="tertiary"
        justifyContent="end"
        onClick={toggleMenu}
      >
        {messages.filtersLabel}
      </Button>

      <div>
        <div
          className={cn(
            "absolute inset-x-0 top-14 z-10 block h-[calc(100%-56px)] lg:hidden",
            {
              invisible: !isOpen,
            }
          )}
        >
          <SearchFilter
            dateRange={dateRange}
            categoryOptions={categoryOptions}
            labelOptions={labelOptions}
            baseUrl={baseUrl}
            redirectUrl={redirectUrl}
            keyword={keyword}
            messages={messages}
            onClick={toggleMenu}
          />
        </div>
      </div>
    </div>
  );
};
